import {
  titleUI,
  yesNoUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import { MedicaidDescription } from '../../../components/FormDescriptions';
import content from '../../../locales/en/content.json';
import { FULL_SCHEMA } from '../../../utils/imports';

const TITLE_TEXT = content['insurance-info--medicaid-title'];
const INPUT_LABEL = content['insurance-info--medicaid-label'];

const { isMedicaidEligible } = FULL_SCHEMA.properties;

export default {
  uiSchema: {
    ...titleUI(TITLE_TEXT, MedicaidDescription),
    isMedicaidEligible: yesNoUI(INPUT_LABEL),
  },
  schema: {
    type: 'object',
    required: ['isMedicaidEligible'],
    properties: { isMedicaidEligible },
  },
};
